import React, { useMemo } from 'react';
import { API, type CmsBillingContext, type CmsBillingExtension } from '@etlyn/etlyn-cms';
import { getCompanyId } from './companyContext';

// Verified from the existing production host on 2026-10-05. No hostname/name inference.
export const INTERNAL_BILLING_TENANT = '5CBmyKc28xr4JFdM94ZY';

export const internalCmsBilling: CmsBillingExtension = {
  async canView(context) {
    if (getCompanyId() !== INTERNAL_BILLING_TENANT || context.tenantId !== INTERNAL_BILLING_TENANT) return false;
    const {data} = await API.get('/billing/square/config', {expectedCompanyId:context.tenantId});
    return data.can_view === true && data.internal_pilot === true && data.environment === 'sandbox';
  },
  async load() {
    const [{createBillingClient}, {BillingPage}] = await Promise.all([
      import('@etlyn/etlyn-billing'), import('@etlyn/etlyn-billing/react'),
      import('@etlyn/etlyn-billing/styles.css'),
    ]);
    function InternalBilling(context: CmsBillingContext) {
      const client = useMemo(() => createBillingClient({transport:{
        request: config => API.request({...config,expectedCompanyId:context.tenantId}),
      }}),[context.tenantId]);
      return <BillingPage presentation="cms-rebrand" client={client} tenantId={context.tenantId} profile={context.profile}
        portalContainer={context.portalContainer} />;
    }
    return context => <InternalBilling {...context} />;
  },
};
